import React from 'react'
import { Container } from 'react-bootstrap'
import withStyles from 'isomorphic-style-loader/withStyles';
import Skeleton from '../../../Common/Skeleton/Skeleton'
import OrderDetailsSkeleton from '../OrderDetailsSkeleton/OrderDetailsSkeleton'
import PriceDetailsSkeleton from '../PriceDetailsSkeleton/PriceDetailsSkeleton'
import ProfileCardSkeleton from '../ProfileCardSkeleton/ProfileCardSkeleton'
import s from './ViewBookingSkeleton.css'

function ViewBookingSkeleton() {
    return (
        <>
            <Skeleton className={s.goBackSkeletonBtn} />
            <div className={s.bookingSkeletonContainer}>
                <div className={s.bookingSkeletonLsBox}>
                    <OrderDetailsSkeleton />
                </div>
                <div className={s.bookingSkeletonRsBox}>
                    <ProfileCardSkeleton />
                    <PriceDetailsSkeleton />
                </div>
            </div>

        </>
    )
}

export default withStyles(s)(ViewBookingSkeleton);
